// Importación de imágenes
import typeScript from "../assets/iconos/typescript.png";
import php from "../assets/iconos/php.png";
import javascript from "../assets/iconos/javascript.png";
import java from "../assets/iconos/java.png";
import laravel from "../assets/iconos/laravel.png";
import react from "../assets/iconos/react.png";
import spring from "../assets/iconos/Spring_Boot.png";
import postgresql from "../assets/iconos/postgresql.png";
import SQLServer from "../assets/iconos/SQLServer.png";
import sveltekit from "../assets/iconos/sveltekit.png";
import fastify from "../assets/iconos/fastify.png";
import oracle from "../assets/iconos/oracle.png";

const technologies = {
  languages: [
    { name: 'TypeScript', icon: typeScript },
    { name: 'PHP', icon: php },
    { name: 'JavaScript', icon: javascript },
    { name: 'Java', icon: java }
  ],
  frameworks: [
    { name: 'Laravel', icon: laravel },
    { name: 'React', icon: react },
    { name: 'Spring Boot', icon: spring },
    { name: 'SvelteKit', icon: sveltekit },
    { name: 'Fastify', icon: fastify }
  ],
  databases: [
    { name: 'Oracle', icon: oracle },
    { name: 'PostgreSQL', icon: postgresql },
    { name: 'SQL Server', icon: SQLServer }
  ]
};

export default technologies;